// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"ac06aede","990":"d96c8aef"}[chunkId] + ".chunk.js";
};